import type { ReactNode, RefObject } from 'react';
import { createContext } from 'react';

export type InternalContextType = {
  colAxisLabelRef: RefObject<HTMLDivElement | null>;
  rowAxisLabelRef: RefObject<HTMLDivElement | null>;
};

export const InternalContext = createContext<InternalContextType>({
  // Context to store references to the column and row axis labels
  // these are used as anchor elements for menus in distant branches of the component tree
  colAxisLabelRef: null,
  rowAxisLabelRef: null,
} as unknown as InternalContextType);

export const InternalContextProvider = ({
  data,
  children,
}: {
  data: InternalContextType;
  children: ReactNode;
}) => {
  return <InternalContext.Provider value={data}>{children}</InternalContext.Provider>;
};
